import { Box, CSSObject } from '@mui/system';
import { PropsWithChildren } from 'react';

export function PageBody({ children, sx }: PropsWithChildren<{ sx?: CSSObject }>) {
  return (
    <Box id="page-body" sx={{ px: 3, pb: 3, display: 'flex', flexDirection: 'row', justifyContent: 'center', ...sx }}>
      {children}
    </Box>
  );
}
